import React, { useEffect, useState } from "react";
import { Link, matchPath, useLocation, useNavigate } from "react-router-dom";
import { NavLinks } from "../../Data/NavbarLink";
import {
  FaAngleDown,
  FaAngleRight,
  FaMusic,
  FaSun,
  FaUser,
} from "react-icons/fa6";
import { FaHandsPraying } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { apiConnector } from "../../Services/ApiConnector";
import { authEndPoints } from "../../Services/AllApi";
import { RiLogoutBoxRLine } from "react-icons/ri";
import { logout } from "../../Services/Operations/AuthOper";
import { IoMenuOutline } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import { FaBook, FaCalendarAlt } from "react-icons/fa";
import { GiByzantinTemple } from "react-icons/gi";
// import { GiTempleGate } from "react-icons/gi";
import { FaVideo } from "react-icons/fa";
import callImage from "../../Assets/call.png"
import gmailImage from "../../Assets/gmail.png"
import whatsappIconImage from "../../Assets/whatsappIcon.png"
import logoImage from "../../Assets/Logo_AnantAradhya.png"
import textLogoImage from "../../Assets/Text_AnantAradhya.png"
import { IoMdHome } from "react-icons/io";
import { useLanguage } from "../../i18n/LanguageContext";
import { FaGlobe } from "react-icons/fa";

// Fallback data for sections if API fails - moved outside component to prevent infinite loop
const getFallbackSections = (t) => [
  {
    title: "Aarti",
    description: t('artiDescription')
  },
  {
    title: "Chalisa",
    description: t('chalisaDescription')
  },
  {
    title: "Mantra",
    description: t('mantraDescription')
  },
  {
    title: "Meditation",
    description: t('meditationDescription')
  }
];

const Navbar = () => {
  const [showLibrary, setshowLibrary] = useState(false);
  const { token, user } = useSelector((state) => state.auth);
  const { GET_USER_API } = authEndPoints;
  const [userData, setuserData] = useState("");
  const naviagte = useNavigate();
  const [showModal, setshowModal] = useState(false);
  const dispatch = useDispatch();
  const [showNavbar, setshowNavbar] = useState(false);

  const [sectionDetail, setsectionDetail] = useState([]);
 
  const [showMobileNavbar, setshowMobileNavbar] = useState(false);
  const { t, language, toggleLanguage } = useLanguage();

  useEffect(() => {
    const getUserDetail = async () => {
      try {
        // Get user ID from localStorage (saved during signup)
        const userId = localStorage.getItem('user_id');
        
        if (!userId) {
          console.log('User ID not found in localStorage');
          return;
        }
        
        const response = await apiConnector("GET", `${GET_USER_API}?user_id=${userId}`, null, {
          Authorization: `Bearer ${token}`,
        });
        setuserData(response?.data);
      } catch (error) {
        console.log('Error fetching user details in Navbar:', error);
      }
    };
    token !== null && getUserDetail();
  }, [GET_USER_API, token]);


  const location = useLocation();

  const matchRoute = (route) => {
    return matchPath({ path: route }, location.pathname);
  };

  useEffect(() => {
    // Use fallback data directly since there's no backend
    setsectionDetail(getFallbackSections(t));
  }, [t]); // Update when translations change

  // Handle escape key to close mobile navbar
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape' && showMobileNavbar) {
        setshowMobileNavbar(false);
      }
    };

    if (showMobileNavbar) {
      document.addEventListener('keydown', handleEscapeKey);
      // Prevent body scroll when mobile navbar is open
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
      document.body.style.overflow = 'unset';
    };
  }, [showMobileNavbar]);

  // Handle click outside to close dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close library dropdown if clicking outside
      if (showLibrary && !event.target.closest('.library-dropdown')) {
        setshowLibrary(false);
      }
      // Close profile modal if clicking outside
      if (showModal && !event.target.closest('.profile-dropdown')) {
        setshowModal(false);
      }
    };

    if (showLibrary || showModal) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showLibrary, showModal]);

  return (
    <>
      <div
        className={`fixed top-0  z-[1000] w-full  bg-white border-b-[1px] border-gray-200 safe-area-top`}
      >
        <div
          className={` flex items-center  flex-row  justify-between py-3  max-w-screen-xl mx-auto lg:px-0 px-5`}
        >
          <Link to={"/"} className="flex items-center gap-4">
            <img src={logoImage} alt="Anant Aradhya Logo" className="h-14 w-auto" />
            <img src={textLogoImage} alt="Anant Aradhya Text" className="h-12 w-auto object-contain" />
          </Link>

          <div className={`hidden lg:block`}>
            <div
              className={`${
                showNavbar ? " flex-col space-y-6 " : "space-x-8 "
              } flex items-center  text-[17px]  font-semibold`}
            >
              {NavLinks.map((data, index) => {
                return (
                  <div key={index}>
                    {data.title === "Library" ? (
                      <div
                        className=" flex items-center gap-2 relative cursor-pointer library-dropdown"
                        onClick={() => setshowLibrary(!showLibrary)}
                      >
                        <p>{t('library')}</p>
                        <FaAngleDown />
                        <div
                          className={`${
                            showLibrary ? "visible" : "hidden"
                          } absolute bg-white rounded-xl p-3 lg:translate-y-[53%] lg:-translate-x-[30%] border-[1px] border-gray-400 lg:min-w-[500px] min-w-[300px] -translate-x-[30%] -translate-y-[55%] z-[10000] transition-all duration-200 flex flex-col gap-2 lg:gap-5 library-dropdown-content`}
                        >
                          {sectionDetail?.slice(0, 4)?.map((data, index) => {
                            return (
                              <div
                                className=" flex  gap-2 items-center text-gray-400 hover:bg-slate-50"
                                key={index}
                                onClick={() => {
                                  setshowLibrary(false);
                                  naviagte(`/songs/${data.title}`);
                                }}
                              >
                                {data.title === "Aarti" ? (
                                  <FaHandsPraying className=" text-orange-500 p-2 rounded-xl text-4xl bg-white shadow-sm shadow-black" />
                                ) : data.title === "Chalisa" ? (
                                  <FaBook className=" text-orange-500 p-2 rounded-xl text-4xl bg-white shadow-sm shadow-black" />
                                ) : data.title === "Mantra" ? (
                                  <GiByzantinTemple className=" text-orange-500 p-2 rounded-xl text-4xl bg-white shadow-sm shadow-black" />
                                ) : data.title === "Meditation" ? (
                                  <FaMusic  className=" text-orange-500 p-2 rounded-xl text-4xl bg-white shadow-sm shadow-black" />
                                ): (
                                  <FaBook className=" text-orange-500 p-2 rounded-xl text-4xl bg-white shadow-sm shadow-black" />
                                )}

                                <div>
                                  <h2 className=" text-orange-500">
                                    {data.title === "Aarti" ? t('arti') : 
                                     data.title === "Chalisa" ? t('chalisa') : 
                                     data.title === "Mantra" ? t('mantra') : 
                                     data.title === "Meditation" ? t('meditation') : 
                                     data.title}
                                  </h2>
                                  <p>{data.description}</p>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    ) : (
                      data.title !== "Library" && (
                      <p
                        className={` ${
                          matchRoute(`${data.path}`)
                            ? " text-orange-500"
                            : " text-black"
                        } hover:text-orange-700 transition-all duration-200 cursor-pointer`}
                        key={data.id}
                        onClick={() => {
                          setshowNavbar(false);
                          setshowLibrary(false);
                          naviagte(`${data.path}`);
                        }}
                      >
                        {data.title === "Home" ? t('home') : data.title === "Astrology" ? t('astrology') : /* data.title === "Temples" ? t('temples') : */ data.title === "Live" ? t('live') : data.title === "Panchang" ? t('panchang') : data.title}
                      </p>
                    )
                    )}
                  </div>
                );
              })}
            </div>
          </div>
          <div className=" flex flex-row items-center gap-2">
            {/* Language Toggle Button */}
            <button
              onClick={toggleLanguage}
              className="flex items-center gap-2 px-3 py-2 text-gray-600 hover:text-orange-500 transition-colors border border-gray-300 rounded-lg hover:border-orange-500"
              title={`Switch to ${language === 'en' ? 'Hindi' : 'English'}`}
            >
              <FaGlobe />
              <span className="text-sm font-medium">
                {language === 'en' ? 'हिंदी' : 'ENG'}
              </span>
            </button>

            <div className=" lg:block  hidden">
              {token === null ? (
                <button
                  className=" text-[15px] rounded-lg  px-5 py-2 bg-gradient-to-r from-orange-500 to-red-400 text-white lg:block hidden"
                  onClick={() => {
                    naviagte('/auth')
                  }}
                >
                  {t('login')}
                </button>
              ) : (
                <div className=" relative profile-dropdown">
                  <div
                    className=" w-[40px] h-[40px] rounded-full cursor-pointer border border-gray-400 bg-gradient-to-r from-orange-500 to-red-500 flex items-center justify-center text-white font-bold text-lg"
                    onClick={() => setshowModal(!showModal)}
                  >
                    {user?.image ? (
                      <img
                        src={user.image}
                        alt="Profile"
                        className="w-full h-full rounded-full object-cover"
                      />
                    ) : (
                      <span>{user?.name ? user.name.charAt(0).toUpperCase() : userData?.firstName ? userData.firstName.charAt(0).toUpperCase() : 'U'}</span>
                    )}
                  </div>
                  <div
                    className={`${
                      showModal ? " block" : " hidden"
                    } absolute right-0 top-12 p-3 border border-gray-200 rounded-xl bg-white shadow-lg flex flex-col gap-2 min-w-[160px] z-50`}
                    onClick={() => setshowModal(false)}
                  >
                    <div
                      className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-orange-50 cursor-pointer transition-colors"
                      onClick={() => naviagte("/profile")}
                    >
                      <FaUser className="text-orange-500" />
                      <p className="text-gray-700 font-medium">{t('profile')}</p>
                    </div>
                    <hr className="w-full h-[1px] bg-gray-200" />
                    <div
                      className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-red-50 cursor-pointer transition-colors"
                      onClick={() => dispatch(logout(naviagte, dispatch))}
                    >
                      <RiLogoutBoxRLine className="text-red-500" />
                      <p className="text-gray-700 font-medium">{t('logout')}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Backdrop overlay for mobile navbar */}
            {showMobileNavbar && (
              <div
                className="fixed inset-0 bg-black bg-opacity-50 z-[199] lg:hidden"
                onClick={() => setshowMobileNavbar(false)}
              />
            )}

            {/* responsive navbar  */}
            <div
              className={`${
                showMobileNavbar ? " block lg:hidden" : " translate-x-[100%]"
              } w-[270px] fixed right-0  top-[69px] h-screen bg-white transition-all duration-500 z-[200] overflow-auto pb-20`}
            >
              <div className=" flex flex-col gap-3 px-4 py-2" onClick={()=> setshowMobileNavbar(false)}>
                <p className=" text-[14px] font-semibold text-gray-600">
                  {t('toCheckAllAvailable')}
                </p>
                {token === null ? (
                  <button
                    className=" p-2 bg-blue-500 text-white rounded-xl"
                    onClick={() => {
                      naviagte('/auth');
                    }}
                  >
                    {t('loginCreateAccount')}
                  </button>
                ) : (
                  <button
                    className=" p-2 bg-blue-500 text-white rounded-xl"
                    onClick={() => dispatch(logout(naviagte, dispatch))}
                  >
                    {t('logout')}
                  </button>
                )}
              </div>
              <hr className=" w-full h-[1px] bg-gray-600" />
              <div className=" flex flex-col gap-3 px-4 py-2" onClick={()=> setshowMobileNavbar(false)}>
                <p className=" text-[14px] font-semibold text-gray-600">
                  {t('accountDetails')}
                </p>
                <Link
                  className=" w-full flex items-center justify-between"
                  to={"/profile"}
                >
                  <div className=" flex items-center gap-2 text-gray-500 px-2 text-sm">
                    <FaUser />
                    {t('myProfile')}
                  </div>
                  <FaAngleRight />
                </Link>

                <hr className=" w-full h-[1px] bg-gray-600" />
                <div className=" flex flex-col gap-2" onClick={()=> setshowMobileNavbar(false)}>
                <p className=" text-[14px] font-semibold text-gray-600">
                  {t('exploreAnantAradhyaServices')}
                </p>
                  {
                    NavLinks.map((data, index)=>{
                      return <Link key={index} className=" flex items-center justify-between " to={data.path} onClick={() => setshowLibrary(false)}>
                      <div className=" flex gap-2  text-gray-500 text-sm items-center ">
                      {
                        data.title === "Home"? <IoMdHome  />: data.title === "Astrology" ? <FaSun />: /* data.title === "Temples" ? <GiTempleGate />: */ data.title === "Live" ? <FaVideo />: data.title === "Panchang" ? <FaSun />: ""
                      }
                        {
                          data.title !== "Library" &&  <p>{data.title === "Home" ? t('home') : data.title === "Astrology" ? t('astrology') : /* data.title === "Temples" ? t('temples') : */ data.title === "Live" ? t('live') : data.title === "Panchang" ? t('panchang') : data.title}</p>
                        }
                      </div>
                        {
                          data.title !== "Library" &&  <FaAngleRight />
                        }
                      </Link>
                    })
                  }
                </div>
                <hr className=" w-full h-[1px] bg-gray-600" />
                          {sectionDetail?.slice(0, 4)?.map((data, index) => {
                            return (
                             <div key={index} className=" w-full flex items-center justify-between">
                             <div
                                className=" flex  gap-2 items-center cursor-pointer text-gray-500 hover:bg-slate-50"
                                onClick={() => {
                                  setshowMobileNavbar(false);
                                  naviagte(`/songs/${data.title}`);
                                }}
                              >
                                {data.title === "Aarti" ? (
                                  <FaHandsPraying className=" p-2 rounded-xl text-3xl bg-white shadow-sm shadow-black" />
                                ) : data.title === "Chalisa" ? (
                                  <FaBook className="  p-2 rounded-xl text-3xl bg-white shadow-sm shadow-black" />
                                ) : data.title === "Mantra" ? (
                                  <GiByzantinTemple className="  p-2 rounded-xl text-3xl bg-white shadow-sm shadow-black" />
                                ) : data.title === "Meditation" ? (
                                  <FaMusic  className="   p-2 rounded-xl text-3xl bg-white shadow-sm shadow-black" />
                                ): (
                                  <FaBook className="   p-2 rounded-xl text-3xl bg-white shadow-sm shadow-black" />
                                )}

                                <div>
                                  <h2 className=" ">
                                  {data.title === "Aarti" ? t('arti') : 
                                   data.title === "Chalisa" ? t('chalisa') : 
                                   data.title === "Mantra" ? t('mantra') : 
                                   data.title === "Meditation" ? t('meditation') : 
                                   `${data?.title?.slice(0, 15)}...`}
                                  </h2>
                                </div>
                              </div>
                              <FaAngleRight />
                             </div>
                            );
                          })}
              </div>
              <hr className=" w-full h-[1px] bg-gray-600" />
              <div className=" flex flex-col gap-3 px-4 py-2" onClick={()=> setshowMobileNavbar(false)}>
              <p className=" text-[14px] font-semibold text-gray-600">
                  {t('helpAndSupport')}
                </p>
                <div className=" p-2 bg-gray-200 rounded-xl flex gap-3 flex-row items-center">
                  <img src={callImage} alt="" className=" w-[30px] -rotate-45 object-cover rounded-full h-[30px]" />
                  <div className=" flex flex-col">
                    <Link to={"tel:+918088905091"} className=" text-[14px] font-semibold">+Whatsapp</Link>
                    <Link to={"tel:+918088905091"} className=" text-[11px] text-gray-500">{t('youCanCallUs')}</Link>

                  </div>
                </div>
                <div className=" flex w-full justify-between">
                          <div className=" p-2 bg-gray-200 rounded-xl flex gap-3 flex-row items-center">
                          <img src={gmailImage} alt="" className=" w-[30px]  object-cover rounded-full h-[30px]" />
                          <Link to={"agastayaprashant@gmail.com"} className=" text-[12px] font-semibold">{t('emailUs')}</Link>
                          </div>
                           <div className=" p-2 bg-gray-200 rounded-xl flex gap-3 flex-row items-center">
                          <img src={whatsappIconImage} alt="" className=" w-[20px]  object-cover rounded-full h-[30px]" />
                          <Link to={"https://wa.me/918088905091"} className=" text-[12px] font-semibold">{t('whatsappUs')}</Link>
                          </div>
                </div>
              </div>
            </div>

            <div className=" lg:hidden block">
              {showMobileNavbar ? (
                <RxCross2
                  className=" cursor-pointer text-lg"
                  onClick={() => setshowMobileNavbar(false)}
                />
              ) : (
                <IoMenuOutline
                  className=" cursor-pointer text-lg"
                  onClick={() => setshowMobileNavbar(true)}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Sticky Shortcuts */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-[999] px-1 py-3 safe-area-bottom">
        <div className="flex justify-around items-center">
          <Link
            to="/"
            className={`flex flex-col items-center gap-1 p-3 rounded-lg transition-colors ${
              matchRoute("/") ? "text-orange-500 bg-orange-50" : "text-gray-600 hover:text-orange-500"
            }`}
            onClick={() => setshowLibrary(false)}
          >
            <IoMdHome className="text-xl" />
            <span className="text-xs font-medium">{t('home')}</span>
          </Link>
          
          <Link
            to="/panchang"
            className={`flex flex-col items-center gap-1 p-3 rounded-lg transition-colors ${
              matchRoute("/panchang") ? "text-orange-500 bg-orange-50" : "text-gray-600 hover:text-orange-500"
            }`}
            onClick={() => setshowLibrary(false)}
          >
            <FaCalendarAlt className="text-xl" />
            <span className="text-xs font-medium">{t('panchang')}</span>
          </Link>
          
          <Link
            to="/songs"
            className={`flex flex-col items-center gap-1 p-3 rounded-lg transition-colors ${
              matchRoute("/songs") ? "text-orange-500 bg-orange-50" : "text-gray-600 hover:text-orange-500"
            }`}
            onClick={() => setshowLibrary(false)}
          >
            <FaMusic className="text-xl" />
            <span className="text-xs font-medium">{t('library')}</span>
          </Link>
          
          <Link
            to="/astrology"
            className={`flex flex-col items-center gap-1 p-3 rounded-lg transition-colors ${
              matchRoute("/astrology") ? "text-orange-500 bg-orange-50" : "text-gray-600 hover:text-orange-500"
            }`}
            onClick={() => setshowLibrary(false)}
          >
            <FaSun className="text-xl" />
            <span className="text-xs font-medium">{t('astrology')}</span>
          </Link>
          
          <Link
            to="/live"
            className={`flex flex-col items-center gap-1 p-3 rounded-lg transition-colors ${
              matchRoute("/live") ? "text-orange-500 bg-orange-50" : "text-gray-600 hover:text-orange-500"
            }`}
            onClick={() => setshowLibrary(false)}
          >
            <FaVideo className="text-xl" />
            <span className="text-xs font-medium">{t('live')}</span>
          </Link>
        </div>
      </div>

    </>
  );
};

export default Navbar;
